<template>
    <div>
    <b-card
        header-tag="header"
        footer-tag="footer">
        <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
            Change Secret
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">docs</small>
            </a>
          </div>
        </div>
        <div>
          <b-row>
            <b-col sm="12">
              <b-alert variant="success" :show="successMessage != ''"> {{ successMessage }} <b-button variant="link" @click="goBack">Back to API Keys List</b-button> </b-alert>
              <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
              <!-- App -->
              <b-form-group>
                <label for="sendTo">Old Secret</label>
                <b-form-input v-model="form.oldSecret" placeholder="Enter old Secret"></b-form-input>
              </b-form-group>
              <!-- Secret -->
              <b-form-group>
                <label for="sendTo">New Secret</label>
                <b-form-input v-model="form.newSecret" placeholder="Enter new secret"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button :disabled="saveDone" @click="updateSecret" class="mr-2" type="button" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
        </div>
    </b-card>
    </div>
</template>
<script>

import ChangeSecretForm from '@/models/changesecret.js';

export default {
  data () {
    return {
      form: {},
      id: '',
      errorMessage: '',
      successMessage: '',
      appName: '',
      fieldErrors: {},
      alertConfirm: false,
      saveDone: false
    };
  },
  created () {
    document.title = 'Change Secret';
    this.prepareForm();
  },
  methods: {
    prepareForm () {
      this.form = new ChangeSecretForm({ id: this.$route.params.id, oldSecret: '', newSecret: '' });
      this.appName = sessionStorage.getItem('AppNameSecret');
    },
    updateSecret () {
      const fd = new FormData();
      fd.append('oldSecret', this.form.oldSecret);
      fd.append('newSecret', this.form.newSecret);
      this.successMessage = '';
      this.errorMessage = '';
      this.axios({
        method: 'post',
        url: (process.env.VUE_APP_URL_MESSAGING_API + '/api-key/' + this.form.id + '/change-secret'),
        data: fd
      }).then(res => {
        const respData = res.data;
        if ('Success' === respData.message) {
          this.saveDone = true;
          this.successMessage = `Secret key successfully updated for ${this.appName}.`;
          sessionStorage.removeItem('AppNameSecret');
        }
      })
        .catch(error => {
          this.saveError = true;
          console.log('Error :', error.response.data.data);
          this.errorMessage = error.response.data.data.length > 0 ? error.response.data.data.map(value => value.msg).join(', ') : 'System Error';
        });
    },
    goBack () {
      sessionStorage.removeItem('AppNameSecret');
      this.$router.push({ name: 'messaging-api-key' });
    }
  }
};
</script>
